import { Type } from 'class-transformer';

export class UserSelectedEventCategoryDto {
	id: string;
	user_id: string;
	category_id: string;
	@Type(() => Date)
	created_date: Date;
}

export class UsersDto {
	id: string;
	email?: string | null;
	role: string;
	full_name?: string | null;
	username?: string | null;
	img_variants?: Record<string, string> | null;
	country?: string | null;
	bio?: string | null;
	is_private?: boolean | null;
	login_streak: number;
	@Type(() => Date)
	app_review_prompt_date?: Date | null;
	img_parent_id?: string | null;
	viewed_popups?: Record<string, boolean | Record<string, boolean>> | null;
	@Type(() => Date)
	birthday?: Date | null;
	college?: string | null;
	@Type(() => UserSelectedEventCategoryDto)
	userSelectedEventCategories?: UserSelectedEventCategoryDto[] | null;
	@Type(() => Date)
	last_seen_date?: Date | null;
	googleEmail?: string | null;
	appleEmail?: string | null;
	appleId?: string | null;
}
